export class PremiumResourcePageLinkOption {
    constructor(
        public path: string,
        public title: string
    ) {}

    public static fromData(data): PremiumResourcePageLinkOption {
        return new PremiumResourcePageLinkOption(data.path || data.canonical_url, data.title)
    }
}
